import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInput } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { AuthForm } from "../../../models/auth/auth-form";
import { Router } from "@angular/router";
import { ComponentRoutes } from "../../../models/constants/component-routes";
import { AuthStore } from "../../../stores/auth.store";

@Component({
    selector: "app-sign-in",
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatIconModule,
        MatFormFieldModule,
        MatInput,
        MatButtonModule,
    ],
    templateUrl: "./sign-in.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignInComponent {
    private _router = inject(Router);
    private _authStore = inject(AuthStore);

    public form: FormGroup<AuthForm> = new FormGroup<AuthForm>({
        email: new FormControl("", {
            nonNullable: true,
            validators: [Validators.required],
        }),
        password: new FormControl("", {
            nonNullable: true,
            validators: [Validators.required],
        }),
    });

    public signIn(): void {
        const formData = this.form.getRawValue();

        this._authStore.signIn(formData.email, formData.password).subscribe({
            next: () => this._router.navigateByUrl(ComponentRoutes.offers.root),
            error: () => {},
        });
    }
}
